import React, { ChangeEvent } from "react";
import "./consultaLogs.css";
import { Button } from "@company-mrv/mrv-design-system/components";
import LogService from "../../../lib/api/logs/logService";
import FileSaver from "file-saver";
import ModalComBotaoFechar from '../../../lib/components/modalComBotaoFechar/modalComBotaoFechar';
import MensagemModal from "../../../lib/components/mensagemModal/mensagemModal";
import { PermissoesUsuario } from "../../../lib/share/utils/constantes";
import { SessionStorageUtils } from "../../../lib/share/utils/sessionStorageUtils";

class ConsultaLogs extends React.Component<{}, 
{
    idJornada: any,
    falhaObterArquivo: boolean,
    mensagemErro: string,
    loadingObterArquivo: boolean,
    checkboxAnaliseProposta: any,
    checkboxRegistroAnaliseProposta: any,
    checkboxLimiteSimulacao: any,
    checkboxLimiteNegociacao: any,
    checkboxTabelao: any,
    checkboxAnalisePropostaInvalida: any,
}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {
            idJornada: undefined,
            falhaObterArquivo: false,
            mensagemErro: '',
            loadingObterArquivo: false,
            checkboxAnaliseProposta: false,
            checkboxRegistroAnaliseProposta: false,
            checkboxLimiteSimulacao: false,
            checkboxLimiteNegociacao: false,
            checkboxTabelao: false,
            checkboxAnalisePropostaInvalida: false
        };

        this.setIdJornada = this.setIdJornada.bind(this);
        this.setLogAnaliseProposta = this.setLogAnaliseProposta.bind(this);
        this.setLogRegistroAnaliseProposta = this.setLogRegistroAnaliseProposta.bind(this);
        this.setLogLimiteSimulacao = this.setLogLimiteSimulacao.bind(this);
        this.setLogLimiteNegociacao = this.setLogLimiteNegociacao.bind(this);
        this.setLogTabelao = this.setLogTabelao.bind(this);
        this.setLogAnalisePropostaInvalida = this.setLogAnalisePropostaInvalida.bind(this);
    }

    private readonly input = React.createRef<HTMLInputElement>()

    verificarPermissoes(permissao: any) {
        const permissoesAtuais = SessionStorageUtils.getItemsFromSessionStorage("permissoes");
        if (permissoesAtuais === null) return false;
        
        const permissaoUpper = permissao.toUpperCase();
        const permissoesUpper = permissoesAtuais.map((p: string) => p.toUpperCase());
        
        return permissoesUpper.includes(permissaoUpper);
    }

    setIdJornada(event: ChangeEvent<HTMLInputElement>) {
        this.setState({
            idJornada: event.target.value,
            falhaObterArquivo: false
        });
    }

    setLogAnaliseProposta(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxAnaliseProposta: value});
    }

    setLogRegistroAnaliseProposta(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxRegistroAnaliseProposta: value});
    }

    setLogLimiteSimulacao(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxLimiteSimulacao: value});
    }

    setLogLimiteNegociacao(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxLimiteNegociacao: value});
    }

    setLogTabelao(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxTabelao: value});
    }

    setLogAnalisePropostaInvalida(event: ChangeEvent<HTMLInputElement>)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({checkboxAnalisePropostaInvalida: value});
    }

    limparInput()
    {
        if(this.input?.current)
        {
            this.input.current.value = '';
        }
    }

    limparMensagemErro(): void 
    {
        this.setState({falhaObterArquivo: false, mensagemErro: ''});
    }

    validarStatusBotaoBaixarArquivos()
    {
        if((this.state.idJornada &&
            (this.state.checkboxAnaliseProposta || this.state.checkboxRegistroAnaliseProposta ||
            this.state.checkboxLimiteSimulacao || this.state.checkboxLimiteNegociacao ||
            this.state.checkboxTabelao || this.state.checkboxAnalisePropostaInvalida)))
            {
                return false;
            }

        return true;
    }

    obterLogRequest()
    {
        const logRequest : Promise<any>[] = [];

        if(this.state.checkboxAnaliseProposta && this.verificarPermissoes(PermissoesUsuario.ExportarAnaliseProposta))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '1').then(r => ({name: 'LogAnaliseProposta', result : r})));
        }
        
        if(this.state.checkboxRegistroAnaliseProposta && this.verificarPermissoes(PermissoesUsuario.ExportarRegistroAnaliseProposta))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '2').then(r => ({name: 'LogRegistroAnaliseProposta', result : r})));
        }

        if(this.state.checkboxLimiteSimulacao && this.verificarPermissoes(PermissoesUsuario.ExportarLimiteSimulacao))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '3').then(r => ({name: 'LogLimiteSimulacao', result : r})));
        }

        if(this.state.checkboxLimiteNegociacao && this.verificarPermissoes(PermissoesUsuario.ExportarLimiteNegociacao))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '4').then(r => ({name: 'LogLimiteNegociacao', result : r})));
        }

        if(this.state.checkboxTabelao && this.verificarPermissoes(PermissoesUsuario.ExportarTabelao))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '5').then(r => ({name: 'LogTabelao', result : r})));
        }

        if(this.state.checkboxAnalisePropostaInvalida && this.verificarPermissoes(PermissoesUsuario.ExportarAnalisePropostaInvalida))
        {
            logRequest.push(LogService.obterLog(this.state.idJornada, '6').then(r => ({name: 'LogAnalisePropostaInvalida', result : r})));
        }

        Promise.all(logRequest)
        .then((res: any[]) => 
        {
            for (const element of res) 
            {
                if (element) 
                {
                    const file = new File([element.result.data], element.name+`.zip`, { type: 'application/zip' });
                    FileSaver.saveAs(file);
                }
            }
            
            this.limparInput();

            this.setState({ 
                falhaObterArquivo: false,
                idJornada: undefined,
                checkboxAnaliseProposta: false,
                checkboxRegistroAnaliseProposta: false,
                checkboxLimiteSimulacao: false,
                checkboxLimiteNegociacao: false,
                checkboxTabelao: false,
                loadingObterArquivo: false,
                checkboxAnalisePropostaInvalida: false
            });
        })
        .catch((err: any) => 
        {
            this.setState({
                falhaObterArquivo: true,
                mensagemErro: err?.response?.data?.message,
                loadingObterArquivo: false
            });
        });
    }

    submit = async (e: any) => 
    {
        e.preventDefault();
        this.setState({ loadingObterArquivo: true });
        this.obterLogRequest();
    }

    render() 
    {
        return (
            <section className="card-principal">
                <form className="form-input-arquivo" onSubmit={e => this.submit(e)}>
                    <h1 className="titulo">Consultar Logs</h1>
                    <label htmlFor="parametros" className="titulo-descricao">Insira abaixo Id Jornada a ser consultada.</label>
                    <span className="label-input-consulta">
                        <div className="container-input-consulta">
                            <input type="text" className="input-consulta" value={this.state.idJornada} onChange={this.setIdJornada}
                                    ref={this.input} placeholder="Id Jornada">
                            </input>
                        </div>
                    </span>
                    <table className='borda-tabela'>
                        <tr hidden>
                            <th>Log</th>
                        </tr>
                        <div className='conteudo-log-tabela'> 
                            {this.verificarPermissoes(PermissoesUsuario.ExportarAnaliseProposta) && (
                                <div>
                                    <label> 
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxAnaliseProposta} onChange={this.setLogAnaliseProposta} id="analiseProposta"/>{' '}
                                        Análise Proposta
                                    </label>
                                </div>
                            )}
                            {this.verificarPermissoes(PermissoesUsuario.ExportarAnalisePropostaInvalida) && (
                                <div>
                                    <label>
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxAnalisePropostaInvalida} onChange={this.setLogAnalisePropostaInvalida} id="analisePropostaInvalida"/>{' '}
                                        Análise Proposta Inválida
                                    </label>
                                </div>
                            )}
                            {this.verificarPermissoes(PermissoesUsuario.ExportarRegistroAnaliseProposta) && (
                                <div>
                                    <label>
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxRegistroAnaliseProposta} onChange={this.setLogRegistroAnaliseProposta} id="registroAnaliseProposta"/>{' '}
                                        Registro Análise Proposta
                                    </label>
                                </div>
                            )}
                            {this.verificarPermissoes(PermissoesUsuario.ExportarLimiteSimulacao) && (
                                <div>
                                    <label>
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxLimiteSimulacao} onChange={this.setLogLimiteSimulacao} id="limiteSimulacao"/>{' '}
                                        Limite Simulação
                                    </label>
                                </div>
                            )}
                            {this.verificarPermissoes(PermissoesUsuario.ExportarLimiteNegociacao) && (
                                <div>
                                    <label>    
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxLimiteNegociacao} onChange={this.setLogLimiteNegociacao} id="limiteNegociacao"/>{' '}
                                        Limite Negociação
                                    </label>
                                </div>
                            )}
                            {this.verificarPermissoes(PermissoesUsuario.ExportarTabelao) && (
                                <div>
                                    <label>
                                        <input type="checkbox" ref={this.input} checked={this.state.checkboxTabelao} onChange={this.setLogTabelao} id="tabelao"/>{' '}
                                        Tabelão
                                    </label>
                                </div>
                            )}
                        </div>
                    </table>
                    <Button className="botao-submit" loading={this.state.loadingObterArquivo} size="small" type="submit" disabled={this.validarStatusBotaoBaixarArquivos()}>Baixar Arquivo</Button>
                </form>
                <ModalComBotaoFechar
                    isOpen={this.state.falhaObterArquivo}
                    onRequestClose={() => this.limparMensagemErro()}
                    aoClicarBotaoFecharModal={() => this.limparMensagemErro()}>
                        <MensagemModal 
                            mensagem={`Ocorreu erro ao tentar baixar arquivo ${this.state.mensagemErro ? ': ' + this.state.mensagemErro : ''}`}
                            erro={true}>
                        </MensagemModal>
                </ModalComBotaoFechar>
            </section>
        );
    }
}

export default ConsultaLogs;